import React from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';
import './LoadingSpinner.css';
import { Footer } from '../../footer/Footer.component';

export const LoadingSpinner = () => {
    return <>
        <div className="loading-spinner_container">
            <ProgressSpinner 
                strokeWidth="5" 
                fill="var(--common-page-background)" 
                animationDuration=".8s" />
        </div>
        <Footer />
    </>;
};